/* eslint-disable no-shadow */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Modal from 'react-modal';

import config from 'config';
import {
    checkTariffLimit,
    cloneClient,
    createClient as createClientApi,
    updateCompany as updateCompanyApi
} from 'services/company/api';
import {
    addClient as addClientAction,
    updateClient as updateClientAction,
    updateMemberList as updateMemberListAction
} from 'services/company/action';
import {confirmActionRequested} from 'services/confirmAction/action';
import {handleChange, toggleState} from 'utils/ComponentUtilFunctions';
import CreateClient from './CreateClient';
import Bots from "./new/Bots";

const customStyles = {
    overlay: {
        zIndex: '2000',
        backgroundColor: config.modalBackgroundColor,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '40px',
        border: 'none',
        borderRadius: '20px'
    },
    clientListWrapper: {
        marginTop: '28px',
        minWidth: '690px',
        marginBottom: '28px'
    },
};

class Client extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCreateClientModalOpen: false,
            currentPlan: {},
            updating: false,
            editingName: false,
            activeTabId: -1,
            showChat: {},
        };
        this.toggleState = toggleState.bind(this);
        this.handleChange = handleChange.bind(this);
    }

    createClient = (clientData) => {
        const {addClient, addNotification} = this.props;
        clientData.domain = clientData.name;

        if (clientData.originalClientId) {
            cloneClient(clientData, clientData.originalClientId)
                .then((newClient) => {
                    addClient(newClient);
                    this.setState({
                        isCreateClientModalOpen: false,
                    });
                    addNotification('botAddedSuccessfully', config.notificationLevels.success, {});
                })
                .catch(() => {
                    addNotification('somethingWentWrong', config.notificationLevels.error, {});
                })
        } else {
            createClientApi(clientData)
                .then((newClient) => {
                    addClient(newClient);
                    this.setState({
                        isCreateClientModalOpen: false,
                    });
                    addNotification('botAddedSuccessfully', config.notificationLevels.success, {});
                })
                .catch(() => {
                    addNotification('somethingWentWrong', config.notificationLevels.error, {});
                })
        }

    };

    closeCreateClientModal = () => {
        this.setState({
            isCreateClientModalOpen: false,
        });
    };

    openCreateClientModal = () => {
        const {addNotification} = this.props;
        checkTariffLimit()
            .then(() => {
                this.setState({
                    isCreateClientModalOpen: true,
                });
            })
            .catch(() => {
                addNotification('limitExceeded', config.notificationLevels.error, {});
            })
    };

    handleRemoveClient = (client) => {
        const {confirmAction} = this.props;
        confirmAction(() => {
            this.updateClient({
                status: config.companyStatusMap.deleted,
            }, client);
        });
    };

    updateClient = (updateData, client) => {
        const {updating} = this.state;
        if (updating) {
            return Promise.resolve();
        }

        this.setState({
            updating: true,
        });


        const {updateClientAction, addNotification} = this.props;
        const data = {
            name: client.name,
            image: client.image,
            domain: client.domain,
            nlpEnabled: client.nlpEnabled,
        };


        Object.assign(data, updateData);
        return updateCompanyApi(client.id, data)
            .then(() => {
                updateClientAction(client.id, updateData);
                if (updateData.status === config.companyStatusMap.deleted) {
                    addNotification('botRemovedSuccessfully', config.notificationLevels.success, {});
                }
            })
            .catch(() => {
                addNotification('somethingWentWrong', config.notificationLevels.error, {});
            })
            .finally(() => {
                this.setState({
                    updating: false,
                });
            });
    };

    handleImageChange = (client, imageLink) => {
        this.updateClient({
            image: imageLink,
        }, client);
    };

    render() {
        const {
            company, user, addNotification
        } = this.props;
        const {isCreateClientModalOpen} = this.state;
        const {subs: clients} = company;
        const {tariff} = company;


        return (
            <div style={{height: '100%'}}>
                <Bots
                    addNotification={addNotification}
                    clients={clients}
                    openCreateClientModal={this.openCreateClientModal}
                    closeCreateClientModal={this.closeCreateClientModal}
                    handleRemoveClient={this.handleRemoveClient}
                    createClient={this.createClient}
                    handleImageChange={this.handleImageChange}
                    user={user}
                    tariff={tariff}
                />
                <Modal
                    closeTimeoutMS={config.closeTimeoutMS}
                    isOpen={isCreateClientModalOpen}
                    onRequestClose={this.closeCreateClientModal}
                    style={customStyles}
                >
                    <CreateClient
                        clients={clients}
                        tariff={tariff}
                        createClient={this.createClient}
                        closeCreateClientModal={this.closeCreateClientModal}
                        user={user}
                    />
                </Modal>
            </div>

        );
    }
}

Client.propTypes = {
    company: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
    confirmAction: PropTypes.func.isRequired,
    addClient: PropTypes.func.isRequired,
    updateClientAction: PropTypes.func.isRequired,
    updateMemberList: PropTypes.func.isRequired,
    commonStyles: PropTypes.shape({
        wrapper: PropTypes.object.isRequired,
        title: PropTypes.object.isRequired,
    }).isRequired,
    user: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => ({
    addClient: (newClient) => {
        dispatch(addClientAction(newClient));
    },
    confirmAction: (func, args) => (dispatch(confirmActionRequested(func, args))),
    updateMemberList: (membersUpdate) => {
        dispatch(updateMemberListAction(membersUpdate));
    },
    updateClientAction: (clientId, update) => {
        dispatch(updateClientAction(clientId, update));
    },
});

export default connect(null, mapDispatchToProps)(Client);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/index.jsx